/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCertificateDto
 */
export interface CreateCertificateDto {
    /**
     * Common Name (CN) for the certificate
     * @type {string}
     * @memberof CreateCertificateDto
     */
    commonName: string;
    /**
     * PFX password
     * @type {string}
     * @memberof CreateCertificateDto
     */
    pfxPassword: string;
}

/**
 * Check if a given object implements the CreateCertificateDto interface.
 */
export function instanceOfCreateCertificateDto(value: object): value is CreateCertificateDto {
    if (!('commonName' in value) || value['commonName'] === undefined) return false;
    if (!('pfxPassword' in value) || value['pfxPassword'] === undefined) return false;
    return true;
}

export function CreateCertificateDtoFromJSON(json: any): CreateCertificateDto {
    return CreateCertificateDtoFromJSONTyped(json, false);
}

export function CreateCertificateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCertificateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'commonName': json['commonName'],
        'pfxPassword': json['pfxPassword'],
    };
}

export function CreateCertificateDtoToJSON(value?: CreateCertificateDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'commonName': value['commonName'],
        'pfxPassword': value['pfxPassword'],
    };
}

